<template>
    <div>
        <!-- 悠家民宿房源 -->
        <div class="channel_list">
            <div class="channel_list_title">
                <div class="title_img">
                    <img src="../../image/youjia.png"/>
                </div>
                <div class="title_house_name">悠家民宿</div>
                <div class="title_nav">房态管理|房价管理|订单管理</div>
                <div class="time">上线时间：{{ hourseInfo.dOnlineTime || "暂无" }}</div>
            </div>
            <div class="house_message" v-if="hourseInfo.houseInfoSon">
                <div class="house_img">
                    <img :src="hourseInfo.houseInfoSon.vCoverPic"/>
                </div>
                <div class="house_name">
                    {{ hourseInfo.vHousTitle }}
                </div>
                <div class="house_money">
                    <div class="house_money_list">
                        平日价：￥{{ hourseInfo.houseFavour.mDailyPrice }}/晚
                    </div>
                    <div class="house_money_list">
                        周末价：￥{{ hourseInfo.houseFavour.mWeekEndPrice }}/晚
                    </div>
                    <div class="house_money_list">
                        节日价：￥{{ hourseInfo.houseFavour.mFestivePrice }}/晚
                    </div>
                </div>
            </div>
            <div class="house_operation">
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 0">
                    已下架
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 1">
                    待上线
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 2">
                    已上线
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 3">
                    待审核
                </div>
                <div class="house_status" v-if="hourseInfo.iHourseStatus == 4">
                    审核失败
                </div>
                <div class="house_btn">
                    <el-button type="primary" class="soldOut" @click="createWxCode" >
                        生成链接
                    </el-button>

                </div>
            </div>
        </div>
        <div class="msg-detail">
            <div class="item">
                <div class="item-title item-title-border">
                    <div>
                        生成记录
                    </div>
                </div>
            </div>
            <el-table  :data="tableData">

                <el-table-column label="编号" prop="id"/>
                <el-table-column label="创建时间" prop="createTime"/>
                <el-table-column label="费用" prop="money"/>
                <el-table-column label="押金" prop="deposit"/>
                <el-table-column label="入住时间" prop="checkInTime"/>
                <el-table-column label="退房时间" prop="leaveTime"/>
                <el-table-column label="创建人" prop="createBy"/>
                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="detailView(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="display: flex;justify-content: center;margin-top: 20px">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 15, 20, 25]"
                    :page-size="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
            <el-dialog
                title="生成链接"
                :visible="settingDialogVisible"
                width="25%"
                center>
                <div >
                    <el-form ref="settingForm" :model="settingForm" :rules="rules" label-width="80px" size="mini">
                        <el-form-item label="时间" prop="time">
                            <el-date-picker
                                style="width: 100%"
                                v-model="settingForm.time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>

                        </el-form-item>
                        <el-form-item label="房费" prop="money">
                            <el-input style="width: calc(100% - 20px)" v-model="settingForm.money"></el-input>元
                        </el-form-item>
                        <el-form-item label="押金" prop="deposit">
                            <div style="display:flex;justify-content: space-between">
                                <span>平台代收押金</span>
                               <div style="width: 70%">
                                   <el-input style="width: calc(100% - 20px)" v-model="settingForm.deposit"></el-input>
                                   <span>元</span>
                               </div>
                            </div>
                        </el-form-item>
                    </el-form>
                </div >
                <span slot="footer" class="dialog-footer">
                    <el-button @click="settingDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submit">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog
                title="详情"
                :visible="dialogVisible"
                @close="close"
                width="30%">
                <div >
                    <el-form ref="form" label-width="130px" size="mini">

                        <el-form-item label="直销链接  " prop="roomRate">
                           <el-button type="text">{{detail.directLink}}</el-button>
                            <el-button type="text" @click="myCopy(detail.directLink)">复制</el-button>
                        </el-form-item>
                        <el-form-item label="直销二维码" prop="pledge">
                            <el-image
                                style="width: 200px; height: 200px;"
                                :fit="'cover'"
                                :src="detail.directSalesQrCode||src"
                                >
                            </el-image>
                        </el-form-item>
                    </el-form>
                </div >
                <span slot="footer" class="dialog-footer">

                    <el-button type="primary" @click="dialogVisible = false">关闭</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import {
    DeleteHourse,
    houseChannel,
    houseChannelChange,
    houseChannelInfo,
    getQrCode,getUrlLink,selectHouseGenerate
} from "../../api";
import {format} from "@/utils/util";

export default {
    data() {
        return {
            rules: {
                time: [
                    { required: true, message: '时间不能为空', trigger: 'blur' },
                ],
                money: [
                    { required: true, message: '房价不能为空', trigger: 'blur' },
                ],
            },
            total:0,
            currentPage:1,
            hourseInfo: [],
            src:'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
            tableData:[],
            houseId: "",
            settingDialogVisible:false,
            dialogVisible: false,
            settingForm:{
                time:'',
                money:'',
                deposit:''
            },
            form: {
                houseId: "",
                iChannelId: "",
                vChannelUrl: "",
                mDailyChannel: "",
                mWeekEndChannel: "",
                mFestiveChannel: "",
                vChannelAccount: "",
                iChannelState: "1"
            },
            queryFrom:{
                currentPage:1,
                pageSize:5,
                houseId:''
            },
            detail:{

            }
        };
    },
    created() {
        this.houseId = sessionStorage.getItem("houseId");
        this.houseChannelInfoGet();
        this.queryFrom.houseId=this.houseId
        this.selectHouseGenerate();
    },
    methods: {
        // 查询房源详情
        async houseChannelInfoGet() {
            const {data: res} = await houseChannelInfo({houseId: this.houseId});
            this.hourseInfo = res.data.hourseInfo || "";

        },
        close(){
            if(this.$refs.settingForm){
                this.$refs.settingForm.resetFields();
            }

            this.settingDialogVisible=false;
            this.dialogVisible=false;

        },
        createWxCode(){
            this.settingDialogVisible=true;
        },
        submit(){

            this.$refs['settingForm'].validate((valid) => {
                if (valid) {
                    console.log(this.settingForm)
                    let from = {
                        deposit:this.settingForm.deposit,
                        money:this.settingForm.money,
                        startTime:'',
                        endTime:'',
                        houseId:this.houseId
                    }
                    from.startTime=format('{y}-{m}-{d} {h}:{i}:{s}',this.settingForm.time[0])
                    from.endTime=format('{y}-{m}-{d} {h}:{i}:{s}',this.settingForm.time[1])

                    console.log(from)
                    console.log(JSON.stringify(from));
                  this.getUrlLink(from);


                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getQrCode(from){
            getQrCode(from).then(res=>{
                if(res.data&&res.data.code==200){
                    this.src=res.data.msg
                   /* const blob = new Blob([res.data], {type: "image/jpeg"})
                    const filename =  '1.jpg'
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = filename
                    document.body.appendChild(link)
                    this.src=URL.createObjectURL(blob);
                    link.click()
                    window.setTimeout(function () {
                        URL.revokeObjectURL( blob )
                        document.body.removeChild(link)
                    }, 0)*/
                }

            })
        },
        getUrlLink(from){
            getUrlLink(from).then(res=>{
                console.log(res)
                if(res.data&&res.data.code==200){
                    this.settingDialogVisible=false;
                    this.$message.success('操作成功')
                    this.selectHouseGenerate();
                }
            })
        },
        detailView(row){
            console.log(row)
            this.detail=row;
            this.dialogVisible=true;
        },
        myCopy(data){
            navigator.clipboard.writeText(data)
                .then(() => {
                    this.$message.success('复制成功');
                })
                .catch(err => {
                    this.$message.error('复制失败');
                });


        },
        selectHouseGenerate(){
            selectHouseGenerate(this.queryFrom).then(res=>{
                console.log(res)
                if (res.data.code==200){
                    res.data.data.list.forEach(item=>{

                        item.checkInTime=item.checkInTime?format('{y}-{m}-{d} {h}:{i}:{s}',new Date(item.checkInTime)):''
                        item.leaveTime=item.leaveTime?format('{y}-{m}-{d} {h}:{i}:{s}',new Date(item.leaveTime)):''
                    })
                    this.tableData=res.data.data.list
                    console.log('this.tableData',this.tableData)
                    this.total=res.data.data.total
                }
            })
        },
        handleSizeChange(e){
            console.log(e)
            this.queryFrom.pageSize=e;
            this.selectHouseGenerate()
        },
        handleCurrentChange(e){
            console.log(e)
            this.queryFrom.currentPage=e;
            this.selectHouseGenerate()
        }
    }
};
</script>

<style lang="less" scoped>
.channel_list {
    padding: 15px;
    margin: 24px 0;
    width: 100%;
    height: 246px;
    border: 1px solid #e1e1e1;

    .channel_list_title {
        height: 55px;
        border-bottom: 1px solid #e1e1e1;

        .title_img {
            float: left;
            height: 40px;
            width: 40px;
            border-radius: 8px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .title_house_name {
            margin-top: 7px;
            float: left;
            margin-left: 20px;
            font-weight: bold;
            font-size: 20px;
            color: #171a1e;
        }

        .title_nav {
            margin-left: 10px;
            margin-top: 12px;
            float: left;
            color: #666666;
            font-size: 12px;
        }

        .time {
            float: right;
            font-size: 16px;
            color: #171a1e;
        }
    }

    .house_message {
        position: relative;
        height: 100px;
        padding: 20px 0;
        border-bottom: 1px solid #e1e1e1;

        .house_img {
            float: left;
            width: 96px;
            height: 60px;

            img {
                width: 96px;
                height: 60px;
            }
        }

        .house_name {
            float: left;
            font-weight: bold;
            font-size: 20px;
            width: 708px;
            margin-left: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .house_money {
            position: absolute;
            top: 55px;
            left: 111px;
            height: 21px;

            .house_money_list {
                width: 160px;
                height: 21px;
                font-size: 16px;
                line-height: 21px;
                float: left;
            }
        }
    }

    .house_operation {
        margin-top: 20px;

        .house_status {
            margin-top: 7px;
            float: left;
            font-weight: bold;
            font-size: 16px;
        }
    }

    .house_btn {
        float: right;

        .soldOut {
            background-color: #ef6e2d;
            border: #ef6e2d;
            width: 96px;
            height: 36px;
            float: left;
            margin-right: 10px;
        }

        .compile {
            background-color: #2f80ed;
            border: #2f80ed;
            width: 96px;
            height: 36px;
            float: left;
            margin-right: 10px;
        }

        .delete {
            background-color: #eb5757;
            border: #eb5757;
            width: 96px;
            height: 36px;
            float: left;
        }
    }
}

/deep/ .msg-detail{
    .item{
        margin-bottom: 20px;
        .item-title div{
            border-left: 6px solid #f6b439;
            height: 30px;
            padding-left: 10px;
            line-height: 30px;
            font-size: 20px;
            font-weight: 400;
        }
        .item-title-border{
            border-bottom: 1px solid #e1e1e1;
            padding-bottom: 10px;
        }
    }
}
/deep/ .el-dialog__header{
    text-align: left;
}
</style>
